<!--
 * @Author: van
 * @Date: 2021-09-28 11:40:31
 * @LastEditors: van
 * @LastEditTime: 2021-10-06 19:11:03
-->
<template>
    <el-dialog
        class="choosePlatform"
        :visible.sync="choosePlatformVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="740px"
        :title="$t('goodsList.choosePlatform.dialogTitle')"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <!-- <ul class="logoCont">
                <li
                    v-for="(item, index) in platformList"
                    :key="index"
                    class="logoItem"
                >
                    <el-image
                        style="width: 120px; height: 60px"
                        class="elImage_show"
                        :src="imgList[item.id - 1]"
                        fit="contain"
                        @click="chooseitem(item)"
                    >
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                        <div slot="placeholder" class="image-slot">
                            <i class="el-icon-loading"></i>
                        </div>
                    </el-image>
                </li>
            </ul>-->
            <div class="store-items">
                <div
                    class="store-item"
                    :class="{ active: item.id == platform_id }"
                    v-for="item of platformList"
                    :key="item.id"
                    @click="chooseitem(item)"
                >
                    <img
                        :style="{width: item.code == 'shoplazza' ? '25%' : ''}"
                        :src="
                            require('@/assets/image/goods/' +
                                item.code +
                                '.png')
                        "
                    />
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="choosePlatformVisible = false">
                {{
                $t("goodsList.choosePlatform.close")
                }}
            </el-button>
        </span>
        <add
            :addVisible.sync="addVisible"
            :id="platform_id"
            @successCloseDialog="successCloseDialog"
        ></add>
        <auth
            :authVisible.sync="authVisible"
            :tableItem="tableItem"
            :authKeyList.sync="authKeyList"
        ></auth>
        <!-- <addstore
            :addVisible.sync="addVisible"
            :platform_id="platform_id"
        ></addstore>-->
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import img1 from "@/assets/image/platformlogo/1.png";
import img2 from "@/assets/image/platformlogo/2.png";
import img3 from "@/assets/image/platformlogo/3.png";
import img4 from "@/assets/image/platformlogo/4.png";
import img5 from "@/assets/image/platformlogo/5.png";
import img7 from "@/assets/image/platformlogo/7.png";
import addstore from "./addstore";
import add from "@/views/pages/storePlatform/storeList/add";
import auth from "@/views/pages/storePlatform/storeList/auth";
export default {
    data() {
        return {
            imgList: [img1, img2, img3, img4, img5, "", img7, ""],
            platformList: [],
            authKeyList: [],
            loading: false,
            chooseResult: {},
            addVisible: false,
            authVisible: false,
            platform_id: "",
            tableItem: {}
        };
    },
    methods: {
        closeDialog() {
            this.chooseResult = {};
            this.platform_id = "";
            this.$emit("update:choosePlatformVisible", false);
        },
        /**
         * 平台下拉列表获取
         */
        platformSelect() {
            this.loading = true;
            cmofferApi.platformSelect({type:"listing"}, "get").then(res => {
                if (res) {
                    this.platformList = res.data;
                    this.loading = false;
                }
            });
        },
        chooseitem(item) {
            this.platform_id = item.id;
            cmofferApi.shopSelect({ platform_id: item.id }, "get").then(res => {
                if (res) {
                    if (res.data && res.data.length > 0) {
                        this.chooseResult = item;
                        this.$emit("choosePlatform", {
                            ...this.chooseResult,
                            platform_id: this.platform_id,
                            tableItem: this.productData
                        });
                        this.closeDialog();
                    } else {
                        this.$confirm(
                            `You don't have a shop. Would you like to add a shop now?`,
                            `Tip`,
                            {
                                confirmButtonText: "Next",
                                cancelButtonText: "Cancel",
                                type: "warning"
                            }
                        ).then(() => {
                            this.addVisible = true;
                        });
                    }
                }
            });
        },
        async initialize() {
            await this.platformSelect();
        },
        successCloseDialog(row) {
            console.log("row: ", row);
            this.authVisible = true;
            this.tableItem = row;
            if (row.platform_id == 3) {
                this.authKeyList = [
                    { key: "appid", name: "AppId" },
                    { key: "secret", name: "Secret" },
                    { key: "access_token", name: "Access Token" },
                    { key: "shop", name: "Shop" }
                ];
            } else if (row.platform_id == 4) {
                this.authKeyList = [
                    { key: "AppKey", name: "AppKey" },
                    { key: "AppSecret", name: "AppSecret" },
                    { key: "Token", name: "Token" },
                    { key: "ShopURL", name: "Shop URL" }
                ];
            }
        }
    },
    components: {
        add: add,
        auth: auth,
        addstore: addstore
    },
    props: {
        choosePlatformVisible: Boolean,
        productData: Object
    },
    watch: {
        choosePlatformVisible(value) {
            if (value) {
                this.initialize();
            }
        }
    }
};
</script>
<style lang="scss">
.choosePlatform {
    .container {
        .logoCont {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            li {
                padding: 0 4px;
                margin-bottom: 4px;
                &:hover {
                    transform: scale(1.05, 1.05);
                    .elImage_show {
                        border-color: $color-primary;
                    }
                }
            }
        }
        .store-items {
            display: flex;
            flex-wrap: wrap;
            padding: 30px;
            .store-item {
                width: 140px;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 2px solid #f3f3f3;
                border-radius: 6px;
                box-sizing: border-box;
                margin: 0 30px 30px 0;
                cursor: pointer;
                img {
                    width: 60%;
                }
                &:nth-child(4) {
                    margin-right: 0;
                }
                &:hover {
                    box-shadow: 0 0 5px 0 rgba(200, 200, 200, 0.6);
                }
            }
            .active {
                border-color: $color-primary;
            }
            .shopify {
                img {
                    width: 70%;
                }
            }
            .etsy {
                img {
                    width: 40%;
                }
            }
            .amazon {
                img {
                    width: 50%;
                }
            }
            .ebay {
                img {
                    width: 45%;
                }
            }
        }
    }
}
</style>